import type { AnswerPolarity } from "@/lib/pharmacyFirst/types/pathway.types";

export function getSelectedAnswerClasses(
  polarity: AnswerPolarity | undefined,
  answerIsYes: boolean,
  isDarkMode: boolean
): string {
  const resolved = polarity ?? "yes-negative";

  if (resolved === "neutral") {
    return isDarkMode
      ? "border-gray-300 bg-gray-600 text-white shadow-sm"
      : "border-gray-900 bg-gray-100 text-gray-950 shadow-sm";
  }

  const isGood = resolved === "yes-positive" ? answerIsYes : !answerIsYes;
  if (isGood) {
    return isDarkMode
      ? "border-green-600 bg-green-950 text-green-100 shadow-sm"
      : "border-green-300 bg-green-50 text-green-900 shadow-sm";
  }
  return isDarkMode
    ? "border-red-600 bg-red-950 text-red-100 shadow-sm"
    : "border-red-300 bg-red-50 text-red-900 shadow-sm";
}
